import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AutorizarRecintoPIAEDCamViewModel } from 'src/app/components/_campanias/types/common-cam-types';

@Injectable()
export class EmpresaDeshidratadoraDesautorizadaCamService {
    private endpoint = this.baseUrl + 'api/campanias/empresadesautorizadacam/';
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    /**
     * Autoriza de nuevo (lo saca de la lista negra), la empresa deshidratadora en la campaña.
     * @param id number
     * @returns Observable<any>
     */
    authorize(payload: AutorizarRecintoPIAEDCamViewModel): Observable<any> {
        return this.http.put<AutorizarRecintoPIAEDCamViewModel>(this.endpoint + 'authorize', payload);
    }
}
